module.exports = __webpack_public_path__ + "icon_word_reduce.055a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_word_reduce.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_word_reduce.svg
// module chunks = main